<template>
  <SimpleLoadingChartContainer
    :chart-options="speedsChartOptions"
    :loading="fetchAverageSpeedLoading"
    loading-text="Loading speeds chart data..."
    :elevation="3"
  >
    <template #header>
      <div class="header-container">
        <span class="speeds-chart-title">Speeds</span>
        <LoadingDataRow
          :is-loading="fetchAverageSpeedLoading"
          icon="mdi-speedometer"
          category="Average Speed"
          :value="averageSpeed"
        />
      </div>
    </template>
  </SimpleLoadingChartContainer>
</template>

<script>
import { mapGetters, mapState } from "vuex";
import LoadingDataRow from "./LoadingDataRow.vue";
import SimpleLoadingChartContainer from "../../../core/SimpleLoadingChartContainer.vue";
export default {
  name: "SpeedsChart",
  components: {
    SimpleLoadingChartContainer,
    LoadingDataRow,
  },
  data: function () {
    return {};
  },
  computed: {
    ...mapGetters("vesselInformation/voyageSpeedDataModule", [
      "speedsChartOptions",
    ]),
    ...mapState("vesselInformation/voyageModule", [
      "averageSpeedData",
      "fetchAverageSpeedLoading",
    ]),
    averageSpeed() {
      try {
        return this.averageSpeedData.voyAvgSpeed;
      } catch (error) {
        return "-";
      }
    },
  },
  mounted() {},
  methods: {},
};
</script>

<style scoped>
.header-container {
  display: flex;
  justify-content: space-between;
}

.loading-text {
  color: rgba(0, 0, 0, 0.6);
}

.loading-container {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  flex-direction: column;
  gap: 20px;
}

.speeds-chart-title {
  font-size: 18px;
  font-weight: bold;
  color: var(--color-text);
}
</style>
